import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject, bindable, observable } from "aurelia-framework";
import { getAutocompleteTypeFromProductSource } from "elements/input-autocomplete-type";
import { Models } from "models/core";
import { ErpSystem } from "models/ErpSystem";
import { ErpSystemService } from "services/erp-system-service";
import { ErrorService } from "services/error-service";
import { ProductService } from "services/product-service";

@autoinject
export class SewingThreadTypeServiceForm {
  @bindable
  @observable
  private sewingThreadTypeService: Models.SewingThreadTypeService;
  sewingThreadTypeServiceChanged(sewingThreadTypeService: Models.SewingThreadTypeService) {
      if (sewingThreadTypeService?.Id) {
          void this.setProductName(sewingThreadTypeService.ProductId);
      }
  }

  protected articleNo = '';
  protected isDuplicate = false;

  protected inputAutocompleteType: string = 'generalproduct';
  protected erpSystemSelected = false;
  protected erpSystems: ErpSystem[] = [];

  constructor(
    private productService: ProductService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private erpSystemService: ErpSystemService
  ) {
    void this.getErpSystems();
  }

  private attached() {
    this.eventAggregator.subscribe('sewingThreadTypeServiceIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }

  protected setProductId(event: { detail: { value: string } }) {
    const productId = Number(event.detail.value);
    this.sewingThreadTypeService.ProductId = productId;
    void this.setProductName(productId);
  }

  private async setProductName(productId: number) {
    try {
      if (productId) {
        const product = await this.productService.get(productId);
        this.sewingThreadTypeService.Name = product.Name;
        this.articleNo = product.ArticleNo;
      }
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async getErpSystems() {
    this.erpSystems = await this.erpSystemService.getAll();
  }

  protected setErpSystem(erpSystemProductSource: string) {
    this.inputAutocompleteType = getAutocompleteTypeFromProductSource(erpSystemProductSource);
    this.erpSystemSelected = true;
  }
}